<section class="estimate-measurement-settings-container">
    <div *ngIf="viewSettings.isDragable" class="grip-container" cdkDragHandle>
        <span class="grip"></span>
    </div>
    @if (viewSettings.isOverLayer) {
        <span class="measurements-header">Measurements</span>
    }

    <div
        *ngIf="!states.isEstimateDisabled"
        class="estimate-measurement-settings-actions mx-1"
        [ngClass]="{ 'group-right': viewSettings.isOverLayer && isTakeoffsV2 }">
        @if (isTakeoffsV2) {
            <div class="group-actions-left">
                @if (viewSettings.isOverLayer && hasMeasurements) {
                    <button
                        id="more-actions"
                        tooltip="More actions"
                        container="body"
                        type="button"
                        [cdkMenuTriggerFor]="moreActionsPopOver"
                        class="btn-flat">
                        <i class="fa-thin fa-ellipsis-vertical"></i>
                    </button>
                }

                <button
                    type="button"
                    id="btn-add-measurement-2"
                    class="btn-add-measurement"
                    tooltip="Add measurement"
                    container="body"
                    class="btn-bx-primary"
                    [disabled]="states.isEstimateReadonly || !states.canChangeMeasurements"
                    (click)="addMeasurement()">
                    <i class="fa-solid fa-plus"></i>
                </button>

                <button
                    type="button"
                    id="btn-add-category"
                    class="btn-bx-secondary-stroked"
                    [disabled]="states.isEstimateReadonly || !states.canChangeMeasurements"
                    tooltip="Add category"
                    container="body"
                    (click)="addCategory()">
                    <i class="fa-light fa-folder-plus"></i>
                </button>

                @if (!viewSettings.isOverLayer && hasPlans()) {
                    <button
                        type="button"
                        id="btn-launch-takeoffs"
                        class="btn-bx-secondary-stroked"
                        (click)="launchTakeoffs()"
                        [disabled]="states.isEstimateReadonly || !states.canChangeMeasurements">
                        Launch takeoffs
                    </button>
                }
            </div>
            <div *ngIf="!viewSettings.isOverLayer" class="group-actions-right">
                <app-bx-dropdown
                    *ngIf="viewSettings.hasPrintActions && hasMeasurements"
                    [actions]="printActions"
                    buttonIcon="fa fa-print"
                    (select)="printMeasurements($event)">
                </app-bx-dropdown>

                <app-bx-dropdown
                    *ngIf="states.canEmailMeasurements && viewSettings.hasEmailActions && hasMeasurements"
                    [actions]="emailActions"
                    buttonIcon="far fa-envelope"
                    (select)="emailMeasurements($event)">
                </app-bx-dropdown>

                <button
                    *ngIf="hasMeasurements && !viewSettings.isOverLayer"
                    type="button"
                    id="btn-delete-all-measurements"
                    class="btn-bx-secondary-stroked"
                    [tooltip]="'Delete all measurements'"
                    [disabled]="!states.canDeleteMeasurements || states.isEstimateReadonly"
                    (click)="deleteAllMeasurements()">
                    <i class="fa-light fa-trash"></i>
                </button>

                <button
                    *ngIf="measurementsDrawingStatus.hasDrawing && !viewSettings.isOverLayer"
                    type="button"
                    id="btn-toggle-all-take-offs"
                    class="btn-bx-secondary-stroked"
                    [tooltip]="measurementsDrawingStatus.hasShownDrawing ? 'Hide  all takeoffs' : 'Show all takeoffs'"
                    (click)="toggleAllTakeOffs()">
                    <i class="fa-thin" [ngClass]="measurementsDrawingStatus.hasShownDrawing ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>
            </div>
        } @else {
            <button
                type="button"
                id="btn-add-category"
                class="btn-bx-secondary-stroked"
                [disabled]="states.isEstimateReadonly"
                (click)="addCategory()">
                <i class="fa-solid fa-plus"></i> Add category
            </button>

            <button
                type="button"
                id="btn-add-measurement-2"
                class="btn-add-measurement btn-bx-secondary-stroked"
                [disabled]="states.isEstimateReadonly"
                (click)="addMeasurement()">
                <i class="fa-solid fa-plus"></i> Add measurement
            </button>

            <app-bx-dropdown
                *ngIf="viewSettings.hasPrintActions && hasMeasurements"
                [actions]="printActions"
                buttonIcon="fa fa-print"
                (select)="printMeasurements($event)">
            </app-bx-dropdown>

            <app-bx-dropdown
                *ngIf="states.canEmailMeasurements && viewSettings.hasEmailActions && hasMeasurements"
                [actions]="emailActions"
                buttonIcon="far fa-envelope"
                (select)="emailMeasurements($event)">
            </app-bx-dropdown>

            <ng-container *ngIf="measurementsDrawingStatus">
                <button
                    *ngIf="measurementsDrawingStatus.hasDrawing"
                    type="button"
                    id="btn-toggle-all-take-offs"
                    class="btn-bx-secondary-stroked"
                    (click)="toggleAllTakeOffs()">
                    {{ measurementsDrawingStatus.hasShownDrawing ? 'Hide' : 'Show' }} all takeoffs
                </button>
            </ng-container>

            <app-bx-dropdown-generic
                buttonLabel="System of measurement"
                placement="right"
                [insideClick]="true"
                class="pull-right"
                *ngIf="uomOptions">
                <li role="menuitem" *ngFor="let uomOption of uomOptions">
                    <div>
                        <input
                            legacy-css
                            type="checkbox"
                            [id]="'chk' + uomOption.label"
                            [(ngModel)]="uomOption.value"
                            [disabled]="!uomOption.condition" />
                        <label [for]="'chk' + uomOption.label" [ngClass]="{ 'uom-option-disabled': !uomOption.condition }">
                            {{ uomOption.label }}
                        </label>
                    </div>
                </li>
            </app-bx-dropdown-generic>
        }
    </div>

    <button *ngIf="viewSettings.isExpandable" class="btn-toggle btn-flat" (click)="toggleMeasurements()">
        <i class="fa fa-chevron-up" [ngClass]="{ collaspe: !isExpanded }" aria-hidden="true"></i>
    </button>
</section>

<ng-template #moreActionsPopOver>
    <div class="dropdown-menu-container" cdkMenu>
        <a cdkMenuItem class="btn-flat" (click)="toggleAllTakeOffs()">
            <i class="fa-thin mr-1" [ngClass]="measurementsDrawingStatus.hasShownDrawing ? 'fa-eye-slash' : 'fa-eye'"></i>
            {{ measurementsDrawingStatus.hasShownDrawing ? 'Hide' : 'Show' }} all takeoffs
        </a>

        <a
            id="delete-all-measurements"
            [class.disabled]="!states.canDeleteMeasurements || states.isEstimateReadonly"
            cdkMenuItem
            class="btn-flat"
            (click)="deleteAllMeasurements()"
            ><i class="fa-light fa-trash mr-1"></i> Delete all</a
        >
    </div>
</ng-template>
